import { render, staticRenderFns } from "./time.vue?vue&type=template&id=1232f8cb&scoped=true&"
import script from "./time.vue?vue&type=script&lang=ts&"
export * from "./time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1232f8cb",
  null
  
)

export default component.exports